{
  "ad_break_overlay__ad_counter": "Mainos {adSequenceIndex} / {adBreakTotalAds}",
  "ad_break_overlay__ad_starts_in": {
    "one": "Mainokset näytetään {number} s kuluttua",
    "other": "Mainokset näyteään {number} s kuluttua"
  },
  "ad_break_overlay__video_starts_in": {
    "one": "Mainos. Ohjelma alkaa {number} s kuluttua.",
    "other": "Mainos. Ohjelma alkaa {number} s kuluttua."
  },
  "ad_break_overlay__visit_advertiser": "Mainostajan sivulle",
  "ad_indicator__ad": "Mainos",
  "channels": "Kanavat",
  "chromecast__commercial": "Mainosta näytetään Chromecastilla",
  "chromecast__error": "Chromecast-virhe: {error}",
  "chromecast__loading": "Ladataan",
  "chromecast__playing": "Toistetaan Chromecastilla",
  "controlls__jump_to_live_title": "Katso livenä",
  "controlls__pause_title": "Tauko",
  "controlls__start_over_title": "Aloita alusta",
  "controlls__voting_title": "Äänestystilanne",
  "cta__cast__close": "Sulje",
  "cta__push_next__see_credits": "Katso lopputekstit",
  "error__expired_vod": "%1$s ei ole enää saatavilla.\\nSe on poistunut %2$s",
  "error__playback_drm": "Tapahtui virhe (DRM)",
  "error__playback_hdmi": "Tapahtui virhe (HDMI)",
  "error__subscription": "Päivitä tuotteesi katsoaksesi tätä ohjelmaa",
  "error__subscription_title": "Harmi, tämä ohjelma ei kuulu tilaukseesi",
  "error__user_denied": "Video ei ole katsottavissa",
  "error_message__ad_blocker__header": "Käytätkö mainonnan esto-ohjelmaa?",
  "error_message__ad_blocker__message": "Kytke mainonnan esto-ohjelma (adblocker) pois päältä. Päivitä tämän jälkeen sivu, jonka jälkeen voit jatkaa ohjelmien katselua.",
  "error_message__problem_general": "Jotain meni pieleen",
  "error_message__stream_limit__button_back": "Takaisin",
  "error_message__stream_limit__button_close": "Lopeta",
  "error_message__stream_limit__button_details_about_streaming": "Katselutietosi",
  "error_message__stream_limit__button_details_log_out_instructions": "Jos haluat kirjautua ulos joltain muulta laitteeltasi, voit tehdä sen osoitteessa mtv.fi/omatili",
  "error_message__stream_limit__button_details_log_out_instructions_short": "Voit kirjautua ulos muilta laitteiltasi osoitteessa mtv.fi/omatili",
  "error_message__stream_limit_details__header_playing_now": "Tunnuksellasi katsotaan parhaillaan: ",
  "error_message__stream_limit_single_stream__header": "{eventTitle} on jo käynnissä toisella laitteella",
  "error_message__stream_limit_single_stream__header_this_stream": "Tämä lähetys",
  "error_message__stream_limit_single_stream__message": "Tätä lähetystä voi katsoa samaan aikaan vain yhdellä laitteella. Katsellaksesi tällä laitteella, lopeta katselu ensin yhdellä muista laitteistasi.",
  "error_message__stream_limit_single_stream__message_shortened": "Tätä lähetystä voi katsella samanaikaisesti vain yhdellä laitteella.",
  "error_message__stream_limit_stream_quota__header": "Käyttäjätunnuksesi on käytössä liian monella laitteella",
  "error_message__stream_limit_stream_quota__message": "Voit katsella kahdella laitteella samanaikaisesti. Katsellaksesi tällä laitteella, lopeta katselu ensin yhdellä muista laitteistasi.",
  "error_message__stream_limit_stream_quota__message_shortened": "Sinulla on enimmäismäärä toistoja auki tunnuksellasi",
  "inactive__continue_watching_no": "Ei, lopeta katselu",
  "inactive__continue_watching_question": "Jatketaanko katselua?",
  "inactive__continue_watching_yes": "Kyllä, jatka katselua",
  "language__audio": "Ääni",
  "language__da": "Tanska",
  "language__de": "Saksa",
  "language__default": "Alkuperäisversio",
  "language__dub": "Dubattu",
  "language__dubbing": "Dubattu",
  "language__el": "Kreikka",
  "language__en": "Englanti",
  "language__es": "Espanja",
  "language__fi": "Suomi",
  "language__fr": "Ranska",
  "language__it": "Italia",
  "language__live": "N/A",
  "language__nb": "Kirjanorja",
  "language__nl": "Ohjelmatekstitys",
  "language__no": "Norja",
  "language__no_subtitles": "Ei tekstitystä",
  "language__off": "Pois",
  "language__pt": "Portugali",
  "language__qaa": "Ilman selostusta",
  "language__qaf": "Äänitekstitys (fi)",
  "language__qag": "Ohjelmatekstitys",
  "language__qai": "Ruotsi (AI-käännös)",
  "language__qas": "Äänitekstitys (sv)",
  "language__qol": "Alkuperäiskieli",
  "language__subtitle": "Tekstitys",
  "language__subtitles": "Tekstitys",
  "language__subtitles_and_audio": "Tekstitys ja ääni",
  "language__subtitles_off": "Pois",
  "language__subtitles_size": "Tekstityksen koko",
  "language__sv": "Ruotsi",
  "language__zh": "Kiina",
  "language_ar": "Arabia",
  "language_bg": "Bulgaria",
  "language_cs": "Tsekki",
  "language_dk": "Tanska",
  "language_el": "Kreikka",
  "language_et": "Viro",
  "language_fa": "Persia",
  "language_he": "Heprea",
  "language_hi": "Hindi",
  "language_hr": "Kroatia",
  "language_hu": "Unkari",
  "language_is": "Islanti",
  "language_it": "Italia",
  "language_ja": "Japani",
  "language_lt": "Liettua",
  "language_lv": "Latvia",
  "language_mk": "Makedonia",
  "language_no": "Norja",
  "language_off": "Pois",
  "language_pl": "Puola",
  "language_pt": "Portugali",
  "language_qaa": "Ilman selostusta",
  "language_qad": "Halliäänet",
  "language_qd": "Halliäänet",
  "language_qhi": "Ohjelmatekstitys",
  "language_qvi": "Heikentynyt näkö",
  "language_ro": "Romania",
  "language_role_direct": "Suoratekstitys",
  "language_ru": "Venäjä",
  "language_sk": "Slovakia",
  "language_sl": "Slovenia",
  "language_sq": "Albania",
  "language_sr": "Serbia",
  "language_title": "Puhuttu kieli",
  "language_tr": "Turkki",
  "language_uk": "Ukraina",
  "language_zh": "Kiina",
  "new__channels_open_table": "Avaa taulukko",
  "new__channels_overlay_title": "Kanavat",
  "playback_speed_header": "Toistonopeus",
  "player__a11y__announcement_hiding_controls": "Piilotetaan kontrollit",
  "player__a11y__announcement_hours": "{hours} tuntia",
  "player__a11y__announcement_live": "Live",
  "player__a11y__announcement_minutes": "{minutes} minuuttia",
  "player__a11y__announcement_parental_rating_age": "Ikäraja {ageLimit}.",
  "player__a11y__announcement_parental_rating_anxiety": "ahdistus",
  "player__a11y__announcement_parental_rating_drugs": "huumeet",
  "player__a11y__announcement_parental_rating_reasons": "Syyt: {reasons}.",
  "player__a11y__announcement_parental_rating_sex": "seksi",
  "player__a11y__announcement_parental_rating_violence": "väkivalta",
  "player__a11y__announcement_paused": "Tauolla",
  "player__a11y__announcement_playing": "Toistetaan",
  "player__a11y__announcement_seconds": "{seconds} sekuntia",
  "player__a11y__announcement_shorts_next": "Toistetaan seuraava lyhyt",
  "player__a11y__announcement_shorts_next_on_last_short": "Tämä on viimeinen lyhyt",
  "player__a11y__announcement_shorts_previous": "Toistetaan edellinen lyhyt",
  "player__a11y__announcement_shorts_previous_on_first_short": "Tämä on ensimmäinen lyhyt",
  "player__a11y__announcement_showing_controls": "Näytetään kontrollit",
  "player__a11y__announcement_skip_back_live": "Hypätään taakse livestä {seconds} sekuntia",
  "player__a11y__announcement_skipping_ahead": "Hypätään eteenpäin {seconds} sekuntia",
  "player__a11y__announcement_skipping_back": "Hypätään taakse {seconds} sekuntia",
  "player__a11y__hover_label_airplay_button": "Airplay",
  "player__a11y__hover_label_back_button": "Takaisin",
  "player__a11y__hover_label_enter_fullscreen_button": "Siirry koko näytön tilaan",
  "player__a11y__hover_label_exit_fullscreen_button": "Poistu koko näytön tilasta",
  "player__a11y__hover_label_go_to_live_button": "Siirry liveen",
  "player__a11y__hover_label_go_to_startover_button": "Aloita alusta",
  "player__a11y__hover_label_language_menu_button": "Tekstit ja puhe",
  "player__a11y__hover_label_mute_button": "Mykistä",
  "player__a11y__hover_label_pause_button": "Tauko",
  "player__a11y__hover_label_play_button": "Toista",
  "player__a11y__hover_label_playback_speed_button": "Vaihda toistonopeutta",
  "player__a11y__hover_label_seek_back_button": "Hyppää taaksepäin {seconds}s",
  "player__a11y__hover_label_seek_forward_button": "Hyppää eteenpäin {seconds}s",
  "player__a11y__hover_label_share_button": "Jaa",
  "player__a11y__hover_label_start_cast_button": "Aloita cast",
  "player__a11y__hover_label_stop_cast_button": "Lopeta cast",
  "player__a11y__hover_label_unmute_button": "Poista mykistys",
  "player__a11y__hover_label_voting_button": "Äänestä",
  "player__a11y__label_all_program_genre_filter": "Lajityyppisuodatin",
  "player__a11y__label_all_program_letter_filter": "Kirjainsuodatin",
  "player__a11y__label_button": "Painike",
  "player__a11y__label_chromecast": "Chromecast",
  "player__a11y__label_chromecast_active": "Chromecast aktiivinen",
  "player__a11y__label_chromecast_inactive": "Chromecast ei aktiivinen",
  "player__a11y__label_close_channels": "Sulje kanavat",
  "player__a11y__label_close_language_menu": "Sulje kielimenu",
  "player__a11y__label_close_pause_ad": "Sulje taukomainos",
  "player__a11y__label_close_player": "Sulje toisto",
  "player__a11y__label_hide_controls": "Piilota kontrollit",
  "player__a11y__label_language_selected": "{language} valittu",
  "player__a11y__label_packet_pre_label": "Tuote",
  "player__a11y__label_pause": "Tauko",
  "player__a11y__label_resume": "Jatka toistoa",
  "player__a11y__label_rotate_screen": "Käännä näyttöä",
  "player__a11y__label_shorts_next": "Seuraava lyhyt",
  "player__a11y__label_shorts_previous": "Edellinen lyhyt",
  "player__a11y__label_show_controls": "Näytä kontrollit",
  "player__a11y__label_skip_ahead": "Hyppää eteenpäin {seconds} sekuntia",
  "player__a11y__label_skip_back": "Hyppää taakse {seconds} sekuntia",
  "player__a11y__playback_speed_double": "Tuplanopeus",
  "player__a11y__playback_speed_faster": "Nopeampi",
  "player__a11y__playback_speed_half": "Puolinopeus",
  "player__a11y__playback_speed_normal": "Normaali nopeus",
  "player__a11y__playback_speed_selected": "{selectedSpeed} valittu",
  "player__a11y__playback_speed_slightly_faster": "Hieman nopeampi",
  "player__a11y__voice_over_airplay_button": "airplay",
  "player__a11y__voice_over_back_button": "takaisin",
  "player__a11y__voice_over_close_button": "sulje",
  "player__a11y__voice_over_close_language_menu": "sulje kielimenu",
  "player__a11y__voice_over_close_pause_ad_button": "sulje taukomainos",
  "player__a11y__voice_over_close_playback_speed_menu": "sulje toistonopeudenvalinta",
  "player__a11y__voice_over_current_position": "aika",
  "player__a11y__voice_over_enter_fullscreen_button": "siirry koko näytön tilaan",
  "player__a11y__voice_over_exit_fullscreen_button": "poistu koko näytön tilasta",
  "player__a11y__voice_over_go_to_live": "siirry liveen",
  "player__a11y__voice_over_go_to_start": "katso alusta",
  "player__a11y__voice_over_initial_playback_button": "aloita katselu",
  "player__a11y__voice_over_loading_waiting_for_content": "ladataan, odota",
  "player__a11y__voice_over_mute_button": "mykistä",
  "player__a11y__voice_over_open_language_menu": "avaa kielimenu",
  "player__a11y__voice_over_open_playback_speed_menu": "avaa toistonopeudenvalinta",
  "player__a11y__voice_over_open_share_menu_button": "avaa jakomenu",
  "player__a11y__voice_over_open_voting_button": "äänestä",
  "player__a11y__voice_over_pause_button": "tauko",
  "player__a11y__voice_over_play_button": "toista",
  "player__a11y__voice_over_progress_bar": "{currentTime} koko kestosta {totalTime}",
  "player__a11y__voice_over_refresh_page_button": "lataa sivu uudelleen",
  "player__a11y__voice_over_seek_back_button": "hyppää taaksepäin {seconds} sekuntia",
  "player__a11y__voice_over_seek_forward_button": "hyppää eteenpäin {seconds} sekuntia",
  "player__a11y__voice_over_select_playback_speed": "valitse toistonopeus",
  "player__a11y__voice_over_start_cast_button": "aloita cast",
  "player__a11y__voice_over_stop_cast_button": "lopeta cast",
  "player__a11y__voice_over_time_remaining": "aika jäljellä",
  "player__a11y__voice_over_unmute_button": "poista mykistys",
  "player__a11y__voice_over_video_controls": "videon kontrollit",
  "player__a11y__voice_over_visit_advertiser_button": "siirry mainostajan sivulle",
  "player__a11y__voice_over_volume_slider": "vaihda äänenvoimakkuutta ylös ja alas nuolilla",
  "player__controls__play": "Toista",
  "player__generic_action_disabled__message": "Valitettavasti tämä ohjelmatyyppi ei tue tätä toimintoa",
  "player__pausead_information": "Mainos. Paina play-nappia jatkaaksesi",
  "player__text_size__large": "L",
  "player__text_size__medium": "M",
  "player__text_size__small": "S",
  "player__text_size__x_large": "XL",
  "program_metadata__episode": "Jakso",
  "program_metadata__season": "Kausi",
  "quality__high": "Korkea",
  "quality__low": "Matala",
  "quality__medium": "Normaali",
  "quality__title": "Laatu",
  "quality__unlimited": "Rajoittamaton",
  "refresh_page": "Lataa sivu uudelleen",
  "skip_intro": "Ohita intro",
  "skip_recap": "Ohita kertaus",
  "start_over__start_over": "Katso alusta",
  "start_over__start_over_shortened": "Alkuun",
  "start_over__watch_live": "Katso livenä",
  "start_over__watch_live_shortened": "Liveen",
  "start_over_choice__continue_playing_live_counter": "Jatka katselua livehetkestä {secondsLeft} s kuluttua",
  "start_over_choice__watch_from_beginning": "Aloita alusta",
  "start_over_choice__watch_live": "Aloita livehetkestä",
  "streaming__device_other": "Muu",
  "streaming__locations_title": "Nyt toistetaan",
  "streaming__open_locations": "Katselutiedot"
}
